import './ListTable.scss';
import Component from './ListTable.js';
export default Component;
